import type { StepChannel, StepSignal, Unsubscribe } from './types';

/**
 * Returns a promise that resolves when the channel emits a signal matching
 * one of the given types. Rejects if the channel is disposed or timeout elapses.
 */
export function waitForSignal(
  channel: StepChannel,
  signalTypes: StepSignal['type'][],
  timeoutMs = 30_000,
): Promise<StepSignal> {
  return new Promise<StepSignal>((resolve, reject) => {
    if (channel.status === 'disposed') {
      reject(new Error(`Channel ${channel.channelKey} is disposed`));
      return;
    }

    let unsub: Unsubscribe | undefined;
    let timer: ReturnType<typeof setTimeout> | undefined;

    const cleanup = () => {
      unsub?.();
      if (timer != null) clearTimeout(timer);
    };

    unsub = channel.onSignal((signal) => {
      if (signalTypes.includes(signal.type)) {
        cleanup();
        resolve(signal);
      }
    });

    timer = setTimeout(() => {
      cleanup();
      reject(
        new Error(
          `Timeout waiting for ${signalTypes.join('|')} on channel ${channel.channelKey}`,
        ),
      );
    }, timeoutMs);
  });
}
